import { render } from "./EditWorldItem.vue?vue&type=template&id=51c7b598"
import script from "./EditWorldItem.vue?vue&type=script&lang=js"
export * from "./EditWorldItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__